import React from 'react'
import { Tabs } from 'antd';
import ImagesContent from './PhotosConent';
const { TabPane } = Tabs;

const Affiliation = () => {

  return (
    <div >
      <Tabs defaultActiveKey="1">
        <TabPane tab="Photos" key="1">
          <ImagesContent />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default Affiliation;

